<template>
  <div class="template-container">
    <el-tabs class="mt-3" v-model="type" @tab-click="handleTabClick" type="card">
      <el-tab-pane  :label="$t('resourceManage.resource')" name="resource"></el-tab-pane>
      <el-tab-pane  :label="$t('resourceManage.acceleration')" name="acceleration"></el-tab-pane>
      <el-tab-pane  :label="$t('resourceManage.traffic')" name="traffic"></el-tab-pane>
      <el-tab-pane  :label="$t('resourceManage.order')" name="order"></el-tab-pane>
    </el-tabs>
    <div class="action-bar">
      <el-button type="primary" size="medium" @click="handleAddResource">{{ $t('resourceList.addResource') }}</el-button>
    </div>
    <template>
      <el-form inline ref="form"  label-width="100px">
        <el-form-item :label="$t('resourceList.name')" prop="resource_id">
          <el-select v-model="searchQuery" clearable :placeholder="$t('resourceList.requireResource')">
            <el-option
                v-for="item in allResource"
                :key="item.id"
                :label="item.name"
                :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="mb-0">
          <el-button type="info" @click="handleSearch" size="small">{{$t('system.search')}}</el-button>
          <el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-table
        :data="resourceList"
        border
        v-loading="loading"
        style="width: 100%">
      <el-table-column prop="id" :label="$t('resourceList.id')" width="80" align="center"></el-table-column>
      <el-table-column prop="name" :label="$t('resourceList.name')" min-width="100"></el-table-column>
      <el-table-column prop="description" :label="$t('resourceList.description')" min-width="100"></el-table-column>
      <el-table-column prop="status" :label="$t('resourceList.status')" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? $t('resourceList.enabled') : $t('resourceList.disabled') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('resourceList.operation')" width="180" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEditResource(scope.row)">{{ $t('resourceList.edit') }}</el-button>
          <el-button type="text" size="small" class="delete-btn" @click="handleDeleteResource(scope.row)">{{ $t('resourceList.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[5,10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
      </el-pagination>
    </div>

    <!-- 表单对话框 -->
    <el-dialog
        :title="dialogType === 'add' ? $t('resourceList.addTitle') : $t('resourceList.editTitle')"
        :visible.sync="dialogVisible"
        width="500px"
        append-to-body
        @close="resetForm">
      <el-form :model="resourceForm" :rules="formRules" ref="resourceForm" label-width="100px">
        <el-form-item :label="$t('resourceList.name')" prop="name">
          <el-input v-model="resourceForm.name" :placeholder="$t('resourceList.namePlaceholder')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('resourceList.description')" prop="description">
          <el-input
              type="textarea"
              v-model="resourceForm.description"
              :placeholder="$t('resourceList.descriptionPlaceholder')"
              :rows="4">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('resourceList.status')" prop="status">
          <el-radio-group v-model="resourceForm.status">
            <el-radio :label="1">{{$t('resourceList.enabled')}}</el-radio>
            <el-radio :label="0">{{$t('resourceList.disabled')}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t('resourceList.cancel')}}</el-button>
        <el-button type="primary" @click="submitForm">{{$t('resourceList.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>


export default {
  name: 'ResourceManage',
  data() {
    return {
      type: 'resource',
      // 表格数据
      resourceList: [],
      allResource:[],
      // 加载状态
      loading: false,
      // 搜索关键词
      searchQuery: '',
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      },
      // 表单对话框可见性
      dialogVisible: false,
      // 对话框类型: add-新增, edit-编辑
      dialogType: 'add',
      // 表单数据
      resourceForm: {
        id: null,
        name: '',
        description: '',
        status: 1
      },
      // 表单校验规则
      formRules: {
        name: [
          { required: true, message: this.$t('resourceList.requireName'), trigger: 'blur' },
        ],
        description: [
          { max: 200, message: this.$t('resourceList.descriptionLength'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('resourceList.requireStatus'), trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.fetchResourceList()
    this.getAllResource()
  },
  methods: {
    //获取资源列表
    fetchResourceList() {
      this.loading = true

      const params = {
        page: this.pagination.currentPage,
        limit: this.pagination.pageSize,
        search: this.searchQuery
      }

      this.axios.post('/admin/data/resourceList', params, {
        token: true
      }).then(res => {
        const { status, msg, data } = res
        if (status === 200 && data && data.code === 1) {
          this.resourceList = data.data.list.list || []
          this.pagination.total = data.data.list.total || 0
        } else {
          this.$message.error(msg || this.$t('resourceList.getError'))
          this.resourceList = []
        }

        this.loading = false
      }).catch(error => {
        this.$message.error(error || this.$t('resourceList.getError'))
        this.loading = false
        this.resourceList = []
      })
    },
    getAllResource(){
      this.axios.post('/admin/data/getAllResource',{},{
        token : true
      }).then(res => {
        const { status, msg, data } = res
        if(status === 200 && data && data.code === 1){
          this.allResource = data.data.list;
        }else {
          this.$message.error(msg)
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },
    // 重置搜索条件
    clearSearch() {
      this.searchQuery = ''
      this.handleSearch()  // 重置后重新加载数据
    },

    // 处理搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchResourceList()
    },

    // 处理页码变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchResourceList()
    },

    // 处理每页条数变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.fetchResourceList()
    },

    // 处理添加资源
    handleAddResource() {
      this.dialogType = 'add'
      this.dialogVisible = true
      this.resetForm()
    },

    // 处理编辑资源
    handleEditResource(row) {
      this.dialogType = 'edit'
      this.dialogVisible = true
      this.resourceForm = { ...row }
    },

    // 处理删除资源
    handleDeleteResource(row) {
      this.$confirm(this.$t('resourceList.deleteConfirm'), this.$t('system.prompt'), {
        confirmButtonText: this.$t('system.confirm'),
        cancelButtonText: this.$t('system.cancel'),
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.axios.post('/admin/data/deleteResource', {
          id: row.id
        }, {
          token: true
        }).then(res => {
          if (res.status === 200 && res.data && res.data.code === 1) {
            this.$message.success(res.data.msg || this.$t('system.deleteSuccess'))
            this.fetchResourceList()
          } else {
            this.$message.error(res.data.msg || this.$t('resourceList.deleteError'))
          }
        }).catch(error => {
          console.error('删除失败:', error);
          this.$message.error(error || this.$t('resourceList.deleteError'))
        })
      }).catch(() => {
        this.$message.info(this.$t('resourceList.cancelDelete'))
      }).finally(() => {
        this.loading = false
      })
    },

    // 提交表单
    submitForm() {
      this.$refs.resourceForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const apiUrl = this.dialogType === 'add'
              ? '/admin/data/addResource'
              : '/admin/data/editResource'
          this.axios.post(apiUrl, this.resourceForm, {
            token: true
          }).then(res => {
            console.log(res.data)
            if (res.status === 200 && res.data.code === 1) {
              this.$message.success(res.data.msg ||
                  (this.dialogType === 'add'
                      ? this.$t('resourceList.addSuccess')
                      : this.$t('resourceList.editSuccess')))
              this.dialogVisible = false
              this.fetchResourceList()
            } else {
              this.$message.error(res.msg ||
                  (this.dialogType === 'add'
                      ? this.$t('resourceList.addError')
                      : this.$t('resourceList.editError')))
            }
          }).catch(error => {
            console.error('操作失败:', error)
            this.$message.error(
                this.dialogType === 'add'
                    ? this.$t('resourceList.addError')
                    : this.$t('resourceList.editError'))
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },

    // 重置表单
    resetForm() {
      if (this.$refs.resourceForm) {
        this.$refs.resourceForm.resetFields()
      }
      this.resourceForm = {
        id: null,
        name: '',
        description: '',
        status: 1
      }
    },
    // 处理标签页点击
    handleTabClick(tab) {
      const routeMap = {
        resource: '/cdn/resourceManage',
        acceleration: '/cdn/accelerationManage',
        traffic:'/cdn/trafficManage',
        order:'/cdn/orderManage'
      }

      if (routeMap[tab.name] && this.$route.path !== routeMap[tab.name]) {
        this.$router.push(routeMap[tab.name])
      }
    },
  }
}
</script>

<style scoped>
.template-container {
  padding: 20px;
}

.action-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.search-input {
  width: 300px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.delete-btn {
  color: #F56C6C;
}
</style>